import { __awaiter, __generator } from 'tslib';
import { formatCurrency, getFeatureValueV2, getFeatureEnabled } from '@gig/magic-common';
import { BALANCE_FIAT_CURRENCY_QUERY, Feature } from '@gig/magic-messages';

var compactFormatter = Intl.NumberFormat('en', {
    notation: 'compact',
    // @ts-ignore
    roundingMode: 'floor',
});
var roundDownFormatter = Intl.NumberFormat('en', {
    // @ts-ignore
    roundingMode: 'floor',
    maximumFractionDigits: 0,
});
var compactFormatterWithFraction = Intl.NumberFormat('en', {
    notation: 'compact',
    // @ts-ignore
    roundingMode: 'floor',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
});
var roundDownFormatterWithFraction = Intl.NumberFormat('en', {
    // @ts-ignore
    roundingMode: 'halfEven',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
function getSweepRatio() {
    return __awaiter(this, void 0, void 0, function () {
        var ratio;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFeatureValueV2(Feature.SWEEPCOINS_RATIO, '1')];
                case 1:
                    ratio = _a.sent();
                    return [2 /*return*/, +(ratio || '1') || 1];
            }
        });
    });
}
function formatBalance(amount, abbreviate) {
    if (amount >= 1000000 && abbreviate) {
        return compactFormatterWithFraction.format(amount);
    }
    return amount >= 100000 && abbreviate
        ? compactFormatter.format(amount)
        : roundDownFormatter.format(amount);
}
function formatBalanceWithDigits(amount, abbreviate) {
    return amount >= 100000 && abbreviate
        ? compactFormatterWithFraction.format(amount)
        : roundDownFormatterWithFraction.format(amount);
}
function isSweepcoinsAndFiatRatioEnabled() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFeatureEnabled('show-ratio-between-sweepcoins-and-fiat')];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function calculateRedeemableSweepFiat(amount, isSweepcoinsAndFiatRatioEnabled) {
    return __awaiter(this, void 0, void 0, function () {
        var ratio, value, fiatCurrency, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isSweepcoinsAndFiatRatioEnabled) {
                        return [2 /*return*/, ''];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, getSweepRatio()];
                case 2:
                    ratio = _a.sent();
                    value = amount / ratio;
                    return [4 /*yield*/, window.queryBus.query(BALANCE_FIAT_CURRENCY_QUERY)];
                case 3:
                    fiatCurrency = _a.sent();
                    return [2 /*return*/, formatCurrency(value, fiatCurrency, 2, 'narrowSymbol')];
                case 4:
                    error_1 = _a.sent();
                    console.error('Failed to calculate redeemable sweep fiat:', error_1);
                    return [2 /*return*/, ''];
                case 5: return [2 /*return*/];
            }
        });
    });
}

export { calculateRedeemableSweepFiat, compactFormatter, compactFormatterWithFraction, formatBalance, formatBalanceWithDigits, getSweepRatio, isSweepcoinsAndFiatRatioEnabled, roundDownFormatter, roundDownFormatterWithFraction };
